(function() {
	// globals
	PM.Dashboard = {};

	PM.Dashboard.charts = [];

	// app functions

	// Destroy all Chart.js instances before re-rendering (year switch)
	PM.Dashboard.destroyCharts = function() {
		for (var i = 0; i < PM.Dashboard.charts.length; i++) {
			if (PM.Dashboard.charts[i]) {
				PM.Dashboard.charts[i].destroy();
			}
		}
		PM.Dashboard.charts = [];
	};

	// Read the selected year from the header dropdown (falls back to current year)
	PM.Dashboard.getSelectedYear = function() {
		var $select = $('.js-dash-year');
		if ($select.length) {
			var val = parseInt($select.val(), 10);
			if (!isNaN(val)) return val;
		}
		return new Date().getFullYear();
	};

	PM.Dashboard.formatHours = function(value) {
		return i18next.format(Number(value) || 0, 'number', i18next.language, { maximumFractionDigits: 1 });
	};

	// Monthly chart: planned (bars) vs capacity (dashed line) + logged (line, when available)
	PM.Dashboard.renderMonthlyChart = function(data) {
		var ctx = document.getElementById('js-dash-monthly-chart');
		if (!ctx) return;

		var labels = data.monthly.map(function(m) {
			return new Intl.DateTimeFormat(i18next.language || 'en', { month: 'short' }).format(new Date(data.year, m.month, 1));
		});

		var datasets = [
			{
				label: i18next.t('Planned hours'),
				data: data.monthly.map(function(m) { return m.planned; }),
				backgroundColor: 'rgba(37, 99, 235, 0.7)',
				borderColor: '#2563eb',
				borderWidth: 1,
				borderRadius: 4,
				order: 1
			},
			{
				label: i18next.t('Capacity'),
				data: data.monthly.map(function(m) { return m.capacity; }),
				type: 'line',
				borderColor: '#94a3b8',
				borderDash: [6, 4],
				borderWidth: 2,
				pointRadius: 0,
				fill: false,
				order: 2
			}
		];

		if (data.hasWorklog) {
			datasets.push({
				label: i18next.t('Logged hours'),
				data: data.monthly.map(function(m) { return m.logged; }),
				type: 'line',
				borderColor: '#059669',
				borderWidth: 2,
				pointRadius: 0,
				fill: false,
				order: 3
			});
		}

		var chart = new Chart(ctx, {
			type: 'bar',
			data: { labels: labels, datasets: datasets },
			options: {
				maintainAspectRatio: false,
				interaction: { mode: 'index', intersect: false },
				plugins: {
					legend: { position: 'bottom', labels: { boxWidth: 12, boxHeight: 12, usePointStyle: true } },
					tooltip: {
						callbacks: {
							label: function(context) {
								return context.dataset.label + ': ' + PM.Dashboard.formatHours(context.parsed.y) + 'h';
							}
						}
					}
				},
				scales: {
					x: { grid: { display: false } },
					y: {
						beginAtZero: true,
						ticks: { callback: function(value) { return value + 'h'; } }
					}
				}
			}
		});
		PM.Dashboard.charts.push(chart);
	};

	// Top overallocated: horizontal bar chart of peak weekly hours
	PM.Dashboard.renderOverallocatedChart = function(data) {
		var ctx = document.getElementById('js-dash-overallocated-chart');
		if (!ctx) return;

		var items = data.topOverallocated || [];
		var chart = new Chart(ctx, {
			type: 'bar',
			data: {
				labels: items.map(function(i) { return i.name; }),
				datasets: [{
					label: i18next.t('Peak weekly hours'),
					data: items.map(function(i) { return i.peak; }),
					backgroundColor: '#dc2626',
					borderRadius: 4,
					barThickness: 18
				}]
			},
			options: {
				indexAxis: 'y',
				maintainAspectRatio: false,
				plugins: {
					legend: { display: false },
					tooltip: {
						callbacks: {
							label: function(context) {
								return i18next.t('Peak weekly hours') + ': ' + PM.Dashboard.formatHours(context.parsed.x) + 'h';
							}
						}
					}
				},
				scales: {
					x: {
						beginAtZero: true,
						ticks: { callback: function(value) { return value + 'h'; } }
					},
					y: { grid: { display: false } }
				}
			}
		});
		PM.Dashboard.charts.push(chart);
	};

	// Project health: doughnut of green/yellow/red/no-status projects
	PM.Dashboard.renderHealthChart = function(data) {
		var ctx = document.getElementById('js-dash-health-chart');
		if (!ctx) return;

		var h = data.projectHealth || { green: 0, yellow: 0, red: 0, none: 0 };
		var chart = new Chart(ctx, {
			type: 'doughnut',
			data: {
				labels: [i18next.t('Healthy'), i18next.t('At risk'), i18next.t('Critical'), i18next.t('No status')],
				datasets: [{
					data: [h.green, h.yellow, h.red, h.none],
					backgroundColor: ['#059669', '#d97706', '#dc2626', '#cbd5e1'],
					borderWidth: 0,
					hoverOffset: 4
				}]
			},
			options: {
				maintainAspectRatio: false,
				cutout: '62%',
				plugins: {
					legend: { display: false },
					tooltip: {
						callbacks: {
							label: function(context) {
								return context.label + ': ' + context.parsed;
							}
						}
					}
				}
			}
		});
		PM.Dashboard.charts.push(chart);
	};

	PM.Dashboard.renderDashboardPage = function() {
		PM.Shell.setSidebarActive('dashboard');
		PM.Shell.setBreadcrumb([{ label: i18next.t('Dashboard') }]);

		var year = PM.Dashboard.getSelectedYear();

		$.when(
			$.get('/api/dashboard/overview', { year: year }),
			ejs.preloadTemplate('/app/dashboard/templates/dashboard.ejs')
		).done(function(result) {
			var data = result[0];
			var isCurrentYear = data.year === data.currentYear;

			PM.Dashboard.destroyCharts();

			var hasData = data.peopleCount > 0 && data.activeProjectsCount > 0 && data.hasPlanData;

			$('.js-page-container').html(ejs.rr('/app/dashboard/templates/dashboard.ejs', {
				data: data,
				hasData: hasData,
				isCurrentYear: isCurrentYear
			}));

			// KPI values
			$('.js-dash-people-count').text(data.peopleCount);
			$('.js-dash-projects-count').text(data.activeProjectsCount);
			$('.js-dash-workhours').text(PM.Dashboard.formatHours(data.totalCapacity) + 'h');

			var allocPlanned = isCurrentYear ? data.currentWeek.planned : data.yearAvgPlanned;
			var allocCapacity = data.totalCapacity;
			var allocPct = allocCapacity > 0 ? Math.round(allocPlanned / allocCapacity * 100) : 0;
			$('.js-dash-allocation-value').text(allocPct + '%');

			var allocSub = allocCapacity > 0
				? PM.Dashboard.formatHours(allocPlanned) + ' / ' + PM.Dashboard.formatHours(allocCapacity) + 'h'
				: '0h';
			if (isCurrentYear) {
				allocSub += ' \u00b7 ' + i18next.t('this week');
			} else {
				allocSub += ' \u00b7 ' + i18next.t('avg per week');
			}
			$('.js-dash-allocation-sub').text(allocSub);

			if (hasData) {
				PM.Dashboard.renderMonthlyChart(data);
				PM.Dashboard.renderOverallocatedChart(data);
				PM.Dashboard.renderHealthChart(data);
			}
		});
	};

	// events

	$(document).on('change', '.js-dash-year', function() {
		PM.Dashboard.renderDashboardPage();
	});

	// app startup

	page('/dashboard', function() {
		if (PM.Shell.currentUser && PM.Shell.currentUser.authenticated) {
			PM.Dashboard.renderDashboardPage();
		} else {
			page.redirect('/');
		}
	});
})();
